export const PageNames = {
  CLASS_MGMT_PAGE: 'CLASS_MGMT_PAGE',
  CLASS_EDIT_MGMT_PAGE: 'CLASS_EDIT_MGMT_PAGE',
  CLASS_ENROLL_LEARNER: 'CLASS_ENROLL_LEARNER',
  CLASS_ASSIGN_COACH: 'CLASS_ASSIGN_COACH',
  USER_MGMT_PAGE: 'USER_MGMT_PAGE',
  USER_CREATE_PAGE: 'USER_CREATE_PAGE',
  NEW_USERS_PAGE: 'NEW_USERS_PAGE',
  USERS_TRASH_PAGE: 'USERS_TRASH_PAGE',
  USER_EDIT_PAGE: 'USER_EDIT_PAGE',
  IMPORT_CSV_PAGE: 'IMPORT_CSV_PAGE',
  DATA_EXPORT_PAGE: 'DATA_EXPORT_PAGE',
  FACILITY_CONFIG_PAGE: 'FACILITY_CONFIG_PAGE',
  ALL_FACILITIES_PAGE: 'ALL_FACILITIES_PAGE',
  FILTER_USERS_SIDE_PANEL: 'FILTER_USERS_SIDE_PANEL',
  FILTER_USERS_SIDE_PANEL__NEW_USERS: 'FILTER_USERS_SIDE_PANEL__NEW_USERS',
  FILTER_USERS_SIDE_PANEL__TRASH: 'FILTER_USERS_SIDE_PANEL__TRASH',
  ADD_NEW_USER_SIDE_PANEL: 'ADD_NEW_USER_SIDE_PANEL',
  ADD_NEW_USER_SIDE_PANEL__NEW_USERS: 'ADD_NEW_USER_SIDE_PANEL__NEW_USERS',
  ASSIGN_COACHES_SIDE_PANEL: 'ASSIGN_COACHES_SIDE_PANEL',
  ASSIGN_COACHES_SIDE_PANEL__NEW_USERS: 'ASSIGN_COACHES_SIDE_PANEL__NEW_USERS',
  REMOVE_FROM_CLASSES_SIDE_PANEL: 'REMOVE_FROM_CLASSES_SIDE_PANEL',
  REMOVE_FROM_CLASSES_SIDE_PANEL__NEW_USERS: 'REMOVE_FROM_CLASSES_SIDE_PANEL__NEW_USERS',
  ENROLL_LEARNERS_SIDE_PANEL: 'ENROLL_LEARNERS_SIDE_PANEL',
  ENROLL_LEARNERS_SIDE_PANEL__NEW_USERS: 'ENROLL_LEARNERS_SIDE_PANEL__NEW_USERS',
};

// modal names
export const Modals = {
  CREATE_CLASS: 'CREATE_CLASS',
  DELETE_CLASS: 'DELETE_CLASS',
  EDIT_CLASS_NAME: 'EDIT_CLASS_NAME',
  REMOVE_USER: 'REMOVE_USER',
  CONFIRM_ENROLLMENT: 'CONFIRM_ENROLLMENT',
  CREATE_USER: 'CREATE_USER',
  EDIT_USER: 'EDIT_USER',
  RESET_USER_PASSWORD: 'RESET_USER_PASSWORD',
  DELETE_USER: 'DELETE_USER',
  COPY_CLASS: 'COPY_CLASS',
};

export const pageNameToModuleMap = {
  [PageNames.CLASS_MGMT_PAGE]: 'classManagement',
  [PageNames.CLASS_EDIT_MGMT_PAGE]: 'classEditManagement',
  [PageNames.CLASS_ASSIGN_COACH]: 'classAssignMembers',
  [PageNames.CLASS_ENROLL_LEARNER]: 'classAssignMembers',
  [PageNames.USER_MGMT_PAGE]: 'userManagement',
  [PageNames.FACILITY_CONFIG_PAGE]: 'facilityConfig',
};

export const CSVGenerationStatuses = {
  NO_LOGS_CREATED: 'NOLOGSCREATED',
  GENERATING: 'GENERATING',
  AVAILABLE: 'AVAILABLE',
};

export const CSVImportStatuses = {
  NOT_STARTED: 'NOTSTARTED',
  VALIDATING: 'VALIDATING',
  VALIDATED: 'VALIDATED',
  SAVING: 'SAVING',
  VALIDATION_ERRORS: 'VALIDATION_ERRORS',
  ERRORS: 'ERRORS',
  FINISHED: 'FINISHED',
};

export const UsersExportStatuses = {
  NOT_STARTED: 'NOTSTARTED',
  EXPORTING: 'EXPORTING',
  FINISHED: 'FINISHED',
};

export const ClassesActions = {
  ENROLL_LEARNER: 'ENROLL_LEARNER',
  ASSIGN_COACH: 'ASSIGN_COACH',
};

export const DateRangeFilters = {
  LAST_7_DAYS: 'LAST_7_DAYS',
  LAST_30_DAYS: 'LAST_30_DAYS',
  THIS_MONTH: 'THIS_MONTH',
  LAST_6_MONTHS: 'LAST_6_MONTHS',
  LAST_YEAR: 'LAST_YEAR',
  ALL_TIME: 'ALL_TIME',
};
